var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTargetIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 252,
    viewBox: "0 0 251 252",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.114 252C173.757 252 223.729 201.984 223.729 140.286C223.729 78.589 173.757 28.5732 112.114 28.5732C50.4715 28.5732 0.5 78.589 0.5 140.286C0.5 201.984 50.4715 252 112.114 252Z",
    fill: "#0F4C81"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.1 227.195C160.054 227.195 198.927 188.287 198.927 140.291C198.927 92.2953 160.054 53.3872 112.1 53.3872C64.1472 53.3872 25.2734 92.2953 25.2734 140.291C25.2734 188.287 64.1472 227.195 112.1 227.195Z",
    fill: "#FDFEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.107 201.445C145.851 201.445 173.206 174.067 173.206 140.293C173.206 106.519 145.851 79.1406 112.107 79.1406C78.3635 79.1406 51.0088 106.519 51.0088 140.293C51.0088 174.067 78.3635 201.445 112.107 201.445Z",
    fill: "#0F4C81"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M112.122 172.56C129.923 172.56 144.354 158.117 144.354 140.3C144.354 122.483 129.923 108.04 112.122 108.04C94.3212 108.04 79.8906 122.483 79.8906 140.3C79.8906 158.117 94.3212 172.56 112.122 172.56Z",
    fill: "#FDFEFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.48 49.807L195.438 25.9772L219.679 0L221.424 25.7208L198.48 49.807Z",
    fill: "#0A1D4F",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250.5 30.8484L225.907 28.8452L201.266 52.5628L225.923 55.207L250.5 30.8484Z",
    fill: "#0A1D4F",
    fillOpacity: 0.4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M112.114 142.162L203.747 76.4738C200.849 72.1309 196.205 66.4419 192.106 62.083L113.603 138.044L112.114 142.162Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M225.058 20.7533C221.231 24.6475 217.388 28.5256 213.562 32.4198C204.355 41.7626 195.149 51.0894 185.942 60.4322C174.846 71.6821 163.767 82.9159 152.671 94.1657C143.032 103.941 133.409 113.701 123.771 123.476C119.095 128.22 114.196 132.835 109.697 137.739C109.633 137.803 109.569 137.883 109.489 137.947C106.767 140.704 111.01 144.95 113.731 142.194C117.558 138.3 121.401 134.422 125.228 130.527C134.434 121.185 143.641 111.858 152.847 102.515C163.943 91.2651 175.023 80.0313 186.118 68.7815C195.757 59.006 205.38 49.2465 215.019 39.471C219.694 34.7274 224.593 30.1121 229.093 25.2083C229.157 25.1442 229.221 25.0641 229.301 25C232.023 22.2597 227.78 17.9969 225.058 20.7533Z",
    fill: "#0A1D4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetIllustration);
export default __webpack_public_path__ + "static/media/targetIllustration.75664c7a0cb0c751150188b77320df63.svg";
export { ForwardRef as ReactComponent };